export interface INotificationRestrictions {
  smsEnabled: boolean
  voiceEnabled: boolean
  smsEnabledCountries: string[]
  voiceEnabledCountries: string[]
}

export interface INotificationRestrictionsPutBody extends INotificationRestrictions {}
export interface INotificationRestrictionsResponseBody extends INotificationRestrictions {}

export enum NotificationRestrictionChannel {
  Sms = 'SMS',
  VoiceCall = 'VoiceCall',
}
